import { Suspense, lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import Home from '../app/home';
import RecipesPage from '../app/recipes';
import { Skeleton } from '@/components/ui/skeleton';
import RoutePlaceholder from '../app/route-placeholder';

const Back = lazy(() => import('../app/admin/back'));
const BarVenuesPage = lazy(() => import('../app/bar-venues'));
const MemberPage = lazy(() => import('../app/member'));
const PurchasePage = lazy(() => import('../app/purchase'));
const PaymentPage = lazy(() => import('../app/payment'));
const MallPage = lazy(() => import('../app/mall'));
const ExchangePage = lazy(() => import('../app/exchange'));
const WithdrawPage = lazy(() => import('../app/withdraw'));

const cmsRouteFallback = (
  <div className="min-h-screen bg-background p-8">
    <div className="space-y-4">
      <Skeleton className="h-12 w-full" />
      <Skeleton className="h-64 w-full" />
      <Skeleton className="h-32 w-full" />
    </div>
  </div>
);

export const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/recipes',
    element: <RecipesPage />,
  },
  {
    path: '/bar-venues',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <BarVenuesPage />
      </Suspense>
    ),
  },
  {
    path: '/member',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <MemberPage />
      </Suspense>
    ),
  },
  {
    path: '/account',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <MemberPage />
      </Suspense>
    ),
  },
  {
    path: '/purchase',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <PurchasePage />
      </Suspense>
    ),
  },
  {
    path: '/buy',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <PurchasePage />
      </Suspense>
    ),
  },
  {
    path: '/payment/:orderId',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <PaymentPage />
      </Suspense>
    ),
  },
  {
    path: '/mall',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <MallPage />
      </Suspense>
    ),
  },
  {
    path: '/exchange',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <ExchangePage />
      </Suspense>
    ),
  },
  {
    path: '/withdraw',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <WithdrawPage />
      </Suspense>
    ),
  },
  {
    path: '/cms',
    element: (
      <Suspense fallback={cmsRouteFallback}>
        <Back />
      </Suspense>
    ),
  },
  {
    path: '*',
    element: <RoutePlaceholder />,
  },
];
